import React, { FC, useEffect, useLayoutEffect, useState } from 'react'
import { Dialog as PrimeDialog, DialogProps as PrimeDialogProps } from 'primereact/dialog'
import { DomHandler } from 'primereact/utils'

export const defaultDialogProps = {
    breakpoints: { '960px': '75vw', '641px': '90vw' },
    blockScroll: true,
    closable: true,
    dismissableMask: true,
    draggable: false,
    modal: true,
    style: { width: '40rem' },
}

type FixedDialogProps = 'blockScroll' | 'closable' | 'dismissableMask' | 'draggable' | 'modal'

export type DialogProps = Omit<PrimeDialogProps, FixedDialogProps>

export const Dialog: FC<DialogProps> = ({
    breakpoints = defaultDialogProps.breakpoints,
    style,
    maskStyle,
    ...props
}) => {
    // Percentage and CSS viewport widths change when the root scrollbar gutter returns during exit.
    const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth)

    useEffect(() => {
        const updateViewportWidth = () => setViewportWidth(window.innerWidth)
        window.addEventListener('resize', updateViewportWidth)
        return () => window.removeEventListener('resize', updateViewportWidth)
    }, [])

    useLayoutEffect(() => {
        if (props.visible) {
            DomHandler.blockBodyScroll()
        }
    }, [props.visible])

    return (
        <PrimeDialog
            {...props}
            {...defaultDialogProps}
            breakpoints={breakpoints}
            maskStyle={{ ...maskStyle, width: viewportWidth }}
            style={{ ...defaultDialogProps.style, ...style }}
        />
    )
}
